// import { Box } from "@mui/material";
// // import Discover3 from "./Discover1";
// import Discover from "./Discover";
// import Discover2 from "./Discover2";
// // import Discover4 from "./Discover5";
// import Discover1 from "./Discover1";
// import Discover5 from "./Discover5";

// export default function FeatureSection() {
//   return (
//     <Box
//       sx={{
//         position: "relative",
//         bgcolor: "#fff",
//         py: { xs: 4, md: 4 },
//         px: { xs: 2, md: 4 },
//         overflow: "hidden",
//         minHeight: { xs: "500px", sm: "600px", md: "100vh" },
//       }}
//     >
//       {/* Background Vector Image */}
//       <Box
//         component="img"
//         src="/img1/Vector.png"
//         alt="Vector background"
//         sx={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           objectFit: "cover",
//           zIndex: 0,
//         }}
//       />

//       {/* Mobile Images */}
//       <Box
//         sx={{
//           position: "relative",
//           zIndex: 1,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           gap: { xs: 2, md: 4 },
//         }}
//       >




//         <Discover1 />



//         <Discover2 />





//         <Discover5 />





//         <Discover />





//       </Box>
//     </Box>
//   );
// }

// import { Box } from "@mui/material";
// import Discover from "./Discover";
// import Discover1 from "./Discover1";
// import Discover2 from "./Discover2";
// import Discover5 from "./Discover5";

// export default function FeatureSection() {
//   return (
//     <Box
//       sx={{
//         position: "relative",
//         bgcolor: "#fff",
//         py: { xs: 6, md: 10 },
//         overflow: "hidden",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       {/* Background Vector */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           backgroundImage: "url('/img1/Vector.png')",
//           backgroundSize: "contain",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//           zIndex: 0,
//         }}
//       />

//       {/* Content */}
//       <Box
//         sx={{
//           position: "relative",
//           zIndex: 1,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           gap: { xs: 4, md: 6 },
//           width: { xs: "100%", md: "80%" },
//         }}
//       >
//         <Box sx={{ width: "100%" }}>
//           <Discover1 />
//         </Box>

//         <Box sx={{ width: "100%" }}>
//           <Discover2 />
//         </Box>

//         <Box sx={{ width: "100%" }}>
//           <Discover5 />
//         </Box>

//         <Box sx={{ width: "100%" }}>
//           <Discover />
//         </Box>
//       </Box>
//     </Box>
//   );
// }




// import { Box } from "@mui/material";
// import Discover from "./Discover";
// import Discover1 from "./Discover1";
// import Discover2 from "./Discover2";
// import Discover5 from "./Discover5";

// export default function FeatureSection() {
//   return (
//     <Box
//       sx={{
//         position: "relative",
//         overflow: "hidden",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//       }}
//     >
//       {/* Background Vector */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           backgroundImage: "url('/img1/Vector.png')",
//           backgroundSize: { xs: "cover", sm: "cover", md: "contain" }, 
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//           zIndex: 0,
//         }}
//       />

//       {/* Content */}
//       <Box
//         sx={{
//           position: "relative",
//           zIndex: 1,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           gap: { xs: 4, md: 0},
//           width: { xs: "100%", md: "100%" },
//         }}
//       >
  
//         <Box >
//           <Discover1 />
//         </Box>
//         <Box >
//           <Discover2 />
//         </Box>

//         <Box >
//           <Discover5 />
//         </Box>

//         <Box >
//           <Discover />
//         </Box>
//       </Box>
//     </Box>
//   );
// }



import { Box } from "@mui/material";
import Discover from "./Discover";
import Discover1 from "./Discover1";
import Discover2 from "./Discover2";
import Discover5 from "./Discover5";

export default function FeatureSection() {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: { xs: "1200px", md: "800px" }, // ensures background covers content
        width: "100%",
      }}
    >
      {/* Background Vector */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: "url('/img1/Vector.png')",
          backgroundSize: "cover", // covers entire Box
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: 0,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 8, sm:8,md: 8 }, // spacing between Discover components
          width: { xs: "100%",sm:"100%", md: "100%" },
          py: { xs: 4, md: 0 }, // padding top & bottom
        }}
      >
        <Discover1 />
        <Discover2 />
        <Discover5 />
        <Discover />
      </Box>
    </Box>
  );
}

